import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Switch,
  FormControlLabel,
  Grid,
  InputLabel,
  Select,
  OutlinedInput,
  Box,
  Chip,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { MultiSelect } from "react-multi-select-component";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import configServ from "../../services/config";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";

const PaymentForm = ({
  isCreate,
  setIsCreate,
  onSuccess,
  editData,
  isEdit,
  setEditPaymentData,
  setIsEdit,
}) => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
console.log("editData",editData)
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    gateway_name: "", // selected gateway (e.g., 'razorpay')
    description: "", // gateway description
    api_key: "", // API Key
    api_secret: "", // API Secret
    is_active: true, // toggle switch
  });

  useEffect(() => {
    if (isEdit && editData) {
      setFormData({
        gateway_name: editData.gateway_name || "",
        description: editData.description || "",
        api_key: editData.api_key || "",
        api_secret: editData.api_secret || "",

        is_active: Boolean(editData.is_active),
      });
    }
  }, [isEdit, editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSwitch = (e) => {
    setFormData((prev) => ({
      ...prev,
      is_active: e.target.checked,
    }));
  };

  const handleReset = () => {
    setFormData({
      gateway_name: "", // selected gateway (e.g., 'razorpay')
      description: "", // gateway description
      api_key: "", // API Key
      api_secret: "", // API Secret
      is_active: true, // toggle switch
    });
  };
  const handleClose = () => {
    setIsCreate(false);
    setEditPaymentData(null);
    setIsEdit(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!validateForm()) return;
    setLoading(true);

    const payload = {
      company_id,
      ...formData,
    };

    // Add creator/updater
    if (isEdit) {
      payload.updated_by = user_id;
      payload.id = editData.id; // Make sure this is set in formData during edit
    } else {
      payload.created_by = user_id;
    }

    try {
      const res = isEdit
        ? await configServ.updateJobGateway(payload)
        : await configServ.storeJobPortalGateway(payload);
      // console.log("Response from API:", res);
      if (res.status) {
        await Swal.fire({
          icon: "success",
          title: isEdit ? "job Gateway Updated" : "job Gateway",
          text: `The job Gateway was successfully ${
            isEdit ? "updated" : "created"
          }.`,
        });

        handleReset(); // Reset form
        onSuccess(); // Maybe refetch list
        setIsCreate(false); // Close modal or hide form
      } else {
        Swal.fire({
          icon: "error",
          title: "Operation Failed",
          text: res?.message || "Something went wrong!",
        });
      }
    } catch (err) {
      console.error("job Gateway save error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Server error occurred.",
      });
    } finally {
      setLoading(false);
    }
  };

  const gatewayOptions = [
  { label: "LinkedIn", value: "linkedin" },
  { label: "Indeed", value: "indeed" },
  { label: "Naukri", value: "naukri" },
  { label: "Monster", value: "monster" },
  { label: "Glassdoor", value: "glassdoor" },
  { label: "Foundit (Monster India)", value: "foundit" },
];


  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: -20 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        style={{
          width: "100%",
          backgroundColor: "#f5fafe",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3}>
              <Autocomplete
                disablePortal
                options={gatewayOptions}
                getOptionLabel={(option) => option.label}
                value={
                  gatewayOptions.find(
                    (opt) => opt.value === formData.gateway_name
                  ) || null
                }
                onChange={(e, newValue) =>
                  setFormData({
                    ...formData,
                    gateway_name: newValue?.value || "",
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Gateway Name"
                    size="small"
                    sx={{
                      backgroundColor: "white",
                      borderRadius: 1,
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <TextField
                label="Description"
                name="description"
                fullWidth
                value={formData.description}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white", borderRadius: 1 }}
              />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextField
                label="API Key"
                name="api_key"
                fullWidth
                value={formData.api_key}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white", borderRadius: 1 }}
              />
            </Grid>

            <Grid item xs={6} md={3}>
              <TextField
                label="API Secret"
                name="api_secret"
                fullWidth
                value={formData.api_secret}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white", borderRadius: 1 }}
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={formData.is_active}
                    onChange={handleSwitch}
                    sx={{ m: 1 }}
                  />
                }
                label="Active"
              />
            </Grid>

            <Grid item xs={12}>
              <Box display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="outlined"
                  onClick={() => {
                    if (isEdit) {
                      handleClose(); // close modal or form
                    } else {
                      handleReset(); // reset form fields
                    }
                  }}
                >
                  {isEdit ? "Close" : "Reset"}
                </Button>

                <Button type="submit" variant="contained" disabled={loading}>
                  {loading
                    ? isEdit
                      ? "Updating..."
                      : "Saving..."
                    : isEdit
                    ? "Update portal"
                    : "Save portal"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </motion.div>
    </LocalizationProvider>
  );
};

export default PaymentForm;
